import React from 'react';
import Label from './Label';

const InputFeedback = ({ error }) =>
  error ? <div className="input-feedback">{error}</div> : null;

const TextInput = ({
  type,
  id,
  label,
  error,
  value,
  checked,
  onChange,
  className,
  disabled,
  ...props
}) => {
  const classes = className ? className : ''
  return (
    <div className={`option ${classes}`}>
      <Label htmlFor={id} style={disabled ? {opacity: 0.5} : null}>{label}</Label>
      <input
        disabled={disabled}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        {...props}
      />
      <InputFeedback error={error} />
    </div>
  );
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput.js